import {
  ParagraphLines,
} from "@/ui/components/primitives/Skeleton/ParagraphLines";
import type { FC } from "react";
import { AspectRatio, Skeleton } from "@/ui/components/primitives";
import { HorizontalRule, Stack } from "@/ui/components/layout";

export const ArticleCardSkeleton: FC = () => (
  <article
    data-component="ArticleCardSkeleton"
    className="rounded-sys-sm border border-solid border-component-card-base overflow-hidden shadow-sm"
  >
    <AspectRatio ratio="21:9" className="bg-state-loading" />
    <Stack gap="4" className="p-4">
      <Stack gap="2">
        <ParagraphLines />
        <ParagraphLines />
      </Stack>
      <HorizontalRule />
      <Skeleton className="w-full" />
    </Stack>
  </article>
);
